module.exports = "/images/ingredients-5.png";